export function resolveSupportImageUrl(value, apiBaseUrl) {
  if (!value) return ''
  if (/^(?:https?:|data:|blob:)/.test(value)) return value
  return new URL(
    value,
    `${String(apiBaseUrl || window.location.origin).replace(/\/$/, '')}/`,
  ).toString()
}
